import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../../../api/ApiCall";

export const getUserScreens = createAsyncThunk("getUserScreens", async (userId) => {
  // Backend returns: [1, 2, 5, 8]
  const request = await api(`api/admin/user/${userId}/screens`, "", "get");
  return request;
});

export const updateUserScreens = createAsyncThunk(
  "updateUserScreens",
  async ({ userId, screens }) => {
    const request = await api(`api/admin/user/${userId}/screens`, { screens }, "post");
    return request;
  }
);

const screenSlice = createSlice({
  name: "screens",
  initialState: {
    loading: false,
    screens: [], // Always start as an empty array
    success: null,
    error: null,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getUserScreens.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserScreens.fulfilled, (state, action) => {
        state.loading = false;
        // Defensive check: Ensure we only store an array
        if (Array.isArray(action.payload)) {
            state.screens = action.payload; 
        } else {
            // Fallback if backend wrapper changes
            state.screens = action.payload.screens || action.payload.data || [];
        }
        state.success = "Screens loaded";
        state.error = null;
      })
      .addCase(getUserScreens.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.screens = []; // Reset on error to prevent bad state
      })
      // ... Update handlers remain the same
      .addCase(updateUserScreens.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUserScreens.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
        state.error = null;
      })
      .addCase(updateUserScreens.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});
export default screenSlice.reducer;